export const transformOptions = {dropZeros: true, withFloat: true};